/*
目次：
予約確認モーダルのfunction
予約実行ボタン押下時の処理（通常のPOSTに変更したためコメントアウト）
予約可能日・時間取得のajax
カレンダー設定 （767px以上）
			日付を選択した時
						日付を選択した時のajax
						日付選択時に追加される要素
セレクトボックス  （768px以下）
			予約可能日取得
			日付を選択した時（セレクトボックス ）
			日付選択時に追加される要素
			日付を選択したらスクロール
ブラウザリサイズ時の表示 / 非表示
*/

import MicroModal from 'micromodal';
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid';
import jaLocale from '@fullcalendar/core/locales/ja';

// dateClickに必要
import interactionPlugin from '@fullcalendar/interaction';
var moment = require("moment");

$(function(){
	if ($('.reserve.user-reserve').length > 0){
		function reserveModal() {
			/* **************************
			予約確認モーダル
			*/
			$('.js-reserved-confirm').on(oEventNames.end, function (event) {
				// 開始時間
				var startTimeconfirm = $(this).closest('.reserve-time-item').find('.js-reserve-start-time').val();
				// 開始時間をモーダル内に挿入
				$('#modal-reserved-confirm .date-time .start-time').text(startTimeconfirm );
				// 所要時間（例：90）
				var reserveTime = $('#js-reserve-require_time').val();
				// 所要時間を数値へ
				var reserveTime = Number(reserveTime );
				var endTime=new Date('2022/2/2 '+ startTimeconfirm); // 時間のみ必要なので日付は適当に設定
				// 開始時間に所要時間（分）を足す
				endTime.setMinutes(endTime.getMinutes() + reserveTime);
				// 分が0の時、0埋めにして00にする
				if(endTime.getMinutes() == 0 ) {
					var endTime = String(endTime.getHours()) +':'+ String(endTime.getMinutes()) + '0';
				}else{
					var endTime = String(endTime.getHours()) +':'+ String(endTime.getMinutes());
				}
				// 終了時間をモーダル内に挿入
				$('#modal-reserved-confirm .date-time .end-time').text(endTime);
				// 実施日
				var reserveDay = $('#js-reserve-day').val();
				// 開始時間
				var reserveTime = startTimeconfirm;
				// form用の要素のvalueに実施日と開始時間を入れる
				$('#js-reserve-day-time').val(reserveDay + ' ' + reserveTime);
				// 予約確認モーダルを開く
				if (!bIsScrolling) {
					event.preventDefault();
					MicroModal.show('modal-reserved-confirm', {
						awaitCloseAnimation: true,
						disableScroll: true,
						disableFocus: true,
					});
				}
			});
		}
		// function reserveBtn() {
		// 	/* **************************
		// 		予約実行ボタン押下時の処理（通常のPOSTに変更したためコメントアウト）
		// 	*/
		// 	$('#btnReserve').off('click');
		// 	$('#btnReserve').on('click', function() {
		// 		var reserveId = $('#js-reserve-id').val();
		// 		var reserveRequireTime = $('#js-reserve-require_time').val();
		// 		var reserveDay = $('#js-reserve-day').val();
		// 		var reserveTime = $('#js-reserve-time').val();
		// 		let data = {
		// 						"QuoteAnswerId": reserveId,
		// 						"StartDateTime": reserveDay + ' ' + reserveTime,
		// 						"RequireTime": reserveRequireTime,
		// 		}
		// 		$.ajax({
		// 						type: "POST",
		// 						url: "/mypage/reserve/createReserve",
		// 						data: JSON.stringify(data),
		// 						contentType: "application/json; charset=utf-8",
		// 						dataType : "json",5
		// 						cache: false,
		// 						processData: false,
		// 						headers: {
		// 								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		// 						}
		// 		})
		// 		.then(
		// 			// 取得成功時
		// 			function (json) {
		// 				$.toast({
		// 					heading: '予約が完了しました',
		// 					showHideTransition: 'slide',
		// 					icon: 'success',
		// 					position: 'bottom-right',
		// 					hideAfter: 6000,
		// 				});
		// 				if(json.status == 'error'){
		// 					$.toast({
		// 						heading: '予約が失敗しました。',
		// 						text: '予約に失敗しました。お手数ですが再度お試しいただき、それでも失敗するようでしたら運営会社まで直接ご連絡ください。',
		// 						showHideTransition: 'slide',
		// 						icon: 'error',
		// 						position: 'bottom-right',
		// 						hideAfter: 6000
		// 					});
		// 					return;
		// 				}
		// 			},
		// 			function () {
		// 				$.toast({
		// 						heading: '予約が失敗しました。',
		// 						text: '予約に失敗しました。お手数ですが再度お試しいただき、それでも失敗するようでしたら運営会社まで直接ご連絡ください。',
		// 						showHideTransition: 'slide',
		// 						icon: 'error',
		// 						position: 'bottom-right',
		// 						hideAfter: 6000
		// 				});
		// 			}
		// 		);
		// 	});
		// }

		// ローディング開始
		$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);
			var reserveId = $('#js-reserve-id').val();
			var oCalendarBody = document.getElementById('calendar-body');
			/* **************************
			予約可能日・時間取得のajax
		*/
			$.ajax({
				// ここで選択した日付のデータを取得
				url: "/mypage/reserve/getReserveableDay/" + reserveId,
				type:'GET',
				datatype:'json',
				timeout:30000
			}).
			done(function(oData){
				if(oData.status == 'success'){
					/* **************************
					カレンダー設定 （767px以上）
					*/
					var oCalendarEvents = [];
					// 予約可能日
					$.each(oData.reserveable_days, function(index, val) {
						oCalendarEvents.push({
							backgroundColor: '#fbead4',
							display: 'background',
							start: val
						});
					});
					// // 選択可能開始日
					// var start = oData.reserveable_days[0];
					// // 選択可能終了日
					// var end = oData.reserveable_days.slice(-1)[0];

					var oCalendar = new Calendar(oCalendarBody, {
						headerToolbar : {
							left: 'title',
							right: 'prev,next'
						},
						plugins: [ dayGridPlugin, interactionPlugin ],
						locales: [ jaLocale ],
						locale: 'ja',
						contentHeight:"auto",
						events: oCalendarEvents,
						// 表示期間・選択可能期間を指定できる
						// validRange: {
						// 	start: start,
						// 	end: end
						// },

						// 日付の「日」を削除
						dayCellContent: function(e) {
							e.dayNumberText = e.dayNumberText.replace('日', '');
						},
						/* **************************
						日付を選択した時
					*/
						dateClick: function(info) {

							$(".calendar .date-highlight").removeClass("date-highlight");
							$(info.dayEl).addClass('date-highlight');
							$('#js-reserve-day').val(info.dateStr);

							var date = moment(info.dateStr).format('M月D日');
							$('#modal-reserved-confirm .datetime .date').text(date);

							// 見積もりIDを取得
							var reserveId = $('#js-reserve-id').val();

							/* **************************
							日付を選択した時のajax
							*/
							// 今日から2日後から選択可能   .add(2, 'd')  の部分で調整可能
							if (moment().add(2, 'd').isSameOrBefore(info.dateStr, 'day')){
								// ローディング開始
								$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);
								$.ajax({
									url: "/mypage/reserve/getReserveAbleTimeZone/" + reserveId + '/' + info.dateStr,
									type:'GET',
									datatype:'json',
									timeout:30000
								}).
								done(function(oData){
									if(oData.status == 'success'){
										$('.js-reserve-time').html('');
											if(oData['reserveable_time_zones']) {
												// 曜日を取得
												var weekDate = moment(info.dateStr).format("yy/MM/DD");
												var dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ] ;
												var newDate = new Date( weekDate );
												var newDate = dayOfWeekStrJP[newDate.getDay()];

												// 選択した日付表示
												var sBoxHtml = '<h2 class="reserve-heading js-reserve-heading"><span>';
												sBoxHtml += moment(info.dateStr).format('M月D日') + '（' + newDate + '）';
												sBoxHtml += '</span>の空き状況</h2>';
												sBoxHtml += '<div class="reserve-time-list js-reserve-time-list">';

													/* **************************
													日付選択時に追加される要素
												*/
													// 時間

												$.each(oData['reserveable_time_zones'], function(i, aDatas){
													var aDatasDateStart = aDatas.startTime.date;
													var aDatasDateStartTime = aDatasDateStart.slice(11, 16);
													if(aDatas.isReserveAble != false){
														sBoxHtml += '<div class="reserve-time-item on ver2">';
														sBoxHtml += '<input type="hidden" class="js-reserve-start-time" value="' + aDatasDateStartTime + '">';
														sBoxHtml += '<div class="reserve-time-box"><span>予約可</span></div>';
														sBoxHtml += '<div class="reserve-time-btn button" data-id="' + aDatasDateStartTime   + '"><button class="js-reserved-confirm" type="button"><span>' + aDatasDateStartTime + '&nbsp;~&nbsp;</span>予約する</button></div>';
														sBoxHtml += '</div>';
													}
												});
												sBoxHtml += '</div><!-- /.reserve-time-list -->';
												// 中身が変わったかわかるように一旦非表示にしてから表示
												function loadingEnd() {
													// ローディング終了
													$("#loadingOverlay").fadeOut(500, function () {
															$(this).remove();
													})
												}
												$.when(
													$('.js-reserve-time').append(sBoxHtml)
													).done(function() {
														loadingEnd()
												}).fail(function() {
														console.log('エラー');
												});
												// $.when(
												// 	$('.js-reserve-time').hide(),
												// 	).done(function() {
												// 		$('.js-reserve-time').append(sBoxHtml),
												// 		$('.js-reserve-time').fadeIn(200),
												// 		loadingEnd()
												// }).fail(function() {
												// 		console.log('エラー');
												// });
											}else{
												$('.js-reserve-time').html('');
											}
											reserveModal();
									}else{
										$('.js-reserve-time').html('');
										$.toast({
											heading: 'データの読み込みの際にエラーが発生しました。',
											text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
											showHideTransition: 'slide',
											icon: 'error',
											position: 'bottom-right',
											hideAfter: 6000
										});
									}
								}).
								fail(function(oData, sTextStatus, sErrorThrown){
									$.toast({
										heading: 'データの読み込みに失敗しました',
										text: 'お手数ですが、再度お試しください。',
										showHideTransition: 'slide',
										icon: 'error',
										position: 'bottom-right',
										hideAfter: 6000
									});
								}).
								always(function(oData){});
							} else {
								$('.js-reserve-time').html('');
								// ローディング終了
								$("#loadingOverlay").fadeOut(500, function () {
										$(this).remove();
								})
							}
						},
					});
					$('.fc-bg').removeClass('fc-today');
					oCalendar.render();
					// ローディング終了
					$("#loadingOverlay").fadeOut(500, function () {
							$(this).remove();
					})

						/* **************************
						セレクトボックス  （768px以下）
						*/
						/* **************************
						予約可能日取得
					*/
					$('#select-body').append('<option value="null">日付を選択ください</option>');
					$.each(oData.reserveable_days, function(index, val) {
						var date = moment(val);

						// 曜日を取得
						var weekDate = date.format("yy/MM/DD");
						var dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ] ;
						var newDate = new Date( weekDate );
						var newDate = dayOfWeekStrJP[newDate.getDay()];

						// 日付をフォーマット
						var date = date.format("yy年 M月 D日");

						var sSelectOption = '<option value="'+ val+'">'+ date + '（' + newDate + '）'  +'</option>';
						$('#select-body').append(sSelectOption);
					});
				}else{
					$('#select-body').html('');
					// ローディング終了
					$("#loadingOverlay").fadeOut(500, function () {
							$(this).remove();
					});
					$.toast({
						heading: 'データの読み込みの際にエラーが発生しました。',
						text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: 6000
					});
				}
			}).
			fail(function(oData, sTextStatus, sErrorThrown){
					// ローディング終了
					$("#loadingOverlay").fadeOut(500, function () {
							$(this).remove();
					})
				$.toast({
					heading: 'データの読み込みに失敗しました',
					text: 'お手数ですが、再度お試しください。',
					showHideTransition: 'slide',
					icon: 'error',
					position: 'bottom-right',
					hideAfter: 6000
				});
			}).
			always(function(oData){
				// ローディング終了
					$("#loadingOverlay").fadeOut(500, function () {
							$(this).remove();
					})
			});

			/* **************************
			日付を選択した時（セレクトボックス ）
			*/
			$('[name="select-body"]').on('change',function() {
					var val = $('[name="select-body"]').val();
					var txt = $('[name="select-body"] option:selected').text();
					$('#js-reserve-day').val(val);

					var date = moment(val).format('M月D日');
					$('#modal-reserved-confirm .datetime .date').text(date);
					$.ajax({
						url: "/mypage/reserve/getReserveAbleTimeZone/" + reserveId + '/' + val,
						type:'GET',
						datatype:'json',
						timeout:30000
					}).
					done(function(oData){
						if(oData.status == 'success'){
							$('.js-reserve-time').html('');
							if(oData['reserveable_time_zones']) {
								// 曜日を取得
								var weekDate = moment(val).format("yy/MM/DD");
								var dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ] ;
								var newDate = new Date( weekDate );
								var newDate = dayOfWeekStrJP[newDate.getDay()];

								// 選択した日付表示
								var sBoxHtml = '<h2 class="reserve-heading js-reserve-heading" id="reserveHeading"><span>';
								sBoxHtml += moment(val).format('M月D日') + '（' + newDate + '）';
								sBoxHtml += '</span>の空き状況</h2>';
								sBoxHtml += '<div class="reserve-time-list js-reserve-time-list">';
									/* **************************
									日付選択時に追加される要素
								*/
									// 時間
									$.each(oData['reserveable_time_zones'], function(i, aDatas){
									var aDatasDateStart = aDatas.startTime.date;
									var aDatasDateStartTime = aDatasDateStart.slice(11, 16);
									if(aDatas.isReserveAble != false){
										sBoxHtml += '<div class="reserve-time-item on ver2">';
										sBoxHtml += '	<input type="hidden" class="js-reserve-start-time" value="' + aDatasDateStartTime + '">';
										sBoxHtml += '	<div class="reserve-time-box"><span>予約可</span></div>';
										sBoxHtml += '	<div class="reserve-time-btn button" data-id="' + aDatasDateStartTime   + '"><button class="js-reserved-confirm" type="button"><span>' + aDatasDateStartTime + '&nbsp;~&nbsp;</span>予約する</button></div>';
										sBoxHtml += '</div>';
									}
								});
								sBoxHtml += '</div><!-- /.reserve-time-list -->';
								// 中身が変わったかわかるように一旦非表示にしてから表示
								$.when(
									$('.js-reserve-time').hide(),
									).done(function() {
										$('.js-reserve-time').append(sBoxHtml),
										$('.js-reserve-time').fadeIn(200)
								}).fail(function() {
										console.log('エラー');
								});
								// $('.js-reserve-time').append(sBoxHtml);
									/* **************************
									日付を選択したらスクロール
								*/
								smoothScroll()
								function smoothScroll() {
									var screenWidth = window.innerWidth;
									var headerHight = 0;//ヘッダの高さ
									if (screenWidth >= 1079) {
										headerHight = 85;
									}else if(screenWidth <= 1080 ) {
										headerHight = 60;
									}
									var delayTime = 500;
									var position = $('#reserveHeading').offset().top - headerHight - 30;

									$("html, body").delay(delayTime).animate({ scrollTop: position }, 500);
								}
							}else{
								$('.js-reserve-time').html('');
							}
							reserveModal();
						}else{
							$('.js-reserve-time').html('');
							$.toast({
								heading: 'データの読み込みの際にエラーが発生しました。',
								text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
								showHideTransition: 'slide',
								icon: 'error',
								position: 'bottom-right',
								hideAfter: 6000
							});
						}
					}).
					fail(function(oData, sTextStatus, sErrorThrown){
						$.toast({
							heading: 'データの読み込みに失敗しました',
							text: 'お手数ですが、再度お試しください。',
							showHideTransition: 'slide',
							icon: 'error',
							position: 'bottom-right',
							hideAfter: 6000
						});
					}).
					always(function(oData){});
			});
			/* **************************
			ブラウザリサイズ時の表示 / 非表示
		*/
			$(window).on('load resize', function () {
				var screenWidth = window.innerWidth;
				setTimeout(function(){
					$('#js-reserve-day').val('');
					$('#js-reserve-time').val('');
					$('.js-reserve-time').html('');
					if (screenWidth <= 767) { //767px以上
						$("#select-body").val('null');
					}else{ //768px以下
						$(".calendar .date-highlight").removeClass("date-highlight");
					};
				},500);
			});
	}
	// 予約決定時のローディング
	// 立脇さん クレジットフォーム実装の関連で下記動作を一旦コメントさせて頂きました
	// 必要に応じて再度適用をお願いできればと思います
	// elements\forms\credit-user.blade.php にてフォーム送信時の調整をしているため
	//$(document).on(oEventNames.end,'#btnReserve',function (event) {
	//	if (!bIsScrolling) {
	//		event.preventDefault();
	//		$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);
    //  setTimeout(function () {
    //      $("#formReserve").submit();
    //  }, 300);
	//	}
	//});

	// // ラジオボタンを2回クリックで選択解除
	// if($('input[name="payment_type"]').length) {
	// 	var inputs = $('input[type="radio"]');
	// 	//読み込み時に「:checked」の疑似クラスを持っているinputの値を取得する
	// 	var checked = inputs.filter(':checked').val();
	// 	//インプット要素がクリックされたら
	// 	inputs.on('click', function(){
	// 		//クリックされたinputとcheckedを比較
	// 		if($(this).val() === checked) {
	// 			//inputの「:checked」をfalse
	// 			$(this).prop('checked', false);
	// 			//checkedを初期化
	// 			checked = '';
	// 		} else {
	// 			//inputの「:checked」をtrue
	// 			$(this).prop('checked', true);
	// 			//inputの値をcheckedに代入
	// 			checked = $(this).val();
	// 		}
	// 	});
	// }

	$('#js-credit-card-form').hide();
	$('[name="payment_type"]').on('change',function() {
		const id = $('input:radio[name="payment_type"]:checked').attr('id');
		if(id == 'js-credit-card-pay') {
			$('#js-credit-card-form').fadeIn();
		}else{
			$('#js-credit-card-form').fadeOut();
		}
	});
});
